export default "__VITE_ASSET__BYyeMBtj__"